import styled, { css } from 'styled-components'

export const Day = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 20px;
    margin-right: 12px;
    padding: 2px 8px;
    font-size: 12px;
    letter-spacing: 0.4px;
    color: ${({ theme }) => theme.whiteTwo};
    background: ${(props) => props.state === 0 ? props.theme.grassyGreen : props.theme.pastelRed};
    ${props =>
        (props.state > 0) &&
        css`
            &:before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 50%;
                bottom: 100%;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0 16px 3px 16px;
                border-color: transparent transparent ${({ theme }) => theme.pastelRed} transparent;
                margin-left: -16px;
            }
        `
    };
    ${props =>
        (props.state < 0) &&
        css`
            &:before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 0;
                top: 100%;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 3px 16px 0 16px;
                border-color: ${({ theme }) => theme.pastelRed} transparent transparent transparent;
            }
        `
    };
`

export const DaysStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 3px;
    overflow: hidden;
    ${({ daysLength }) => daysLength && css`
        width: ${`${daysLength * 50}px`};
    `}
`
